import { render } from "./PlanejamentoComponent.vue?vue&type=template&id=32f740f8"
import script from "./PlanejamentoComponent.vue?vue&type=script&lang=js"
export * from "./PlanejamentoComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__